<!--<printheaderview [hasimage]="1">
</printheaderview>-->
<div class="">
  <div class="row">
    <div class="col-print-12 padding-left-0px">
      <div class="card background-color-wt">
        <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

          <div class="row">
            <div class="col-print-12 text-align-center">
              <label class="font-familyhead">Follicular Scan Report</label>
              <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style2" [qrdata]="FormattedCode" [size]="90" [level]="'M'"></qrcode>-->

            </div>
            <!--<div class="col-print-1 padding-top-0px padding-bottom-0px"></div>-->
            <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style2" [qrdata]="FormattedCode" [size]="90" [level]="'M'"></qrcode>-->

          </div>
          <!--<div class="row">
    <div class="col-print-10 text-align-center">
      <label class="margin-bottom-0px margin-top-0px font-familyhead"></label>
    </div>
    <div class="col-print-2 padding-top-0px padding-bottom-0px">
      <qrcode class="padding-top-0px padding-bottom-0px qr-style" [qrdata]="FormattedCode" [size]="90" [level]="'M'"></qrcode>
    </div>
  </div>-->

          <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <!--<div class="row margin-left-0px margin-right-0px">
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
          </div>
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Owner}}</label>
          </div>
        </div>
        <div class="row margin-left-0px margin-right-0px">
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
          </div>
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{Age}}</label>
          </div>
        </div>
        <div class="row margin-left-0px margin-right-0px">
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
          </div>
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family float-left font-weight-normal">{{FormattedCode}}</label>
          </div>
        </div>-->
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Cycle:</label>
                  </div>
                  <div class="col-print-6">
                    <div class="display-inline">
                      <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CycleType}}</label>
                    </div>
                    <div class="display-inline" *ngIf="CycleNo!='null'">
                      <label class="margin-bottom-0px font-family float-left font-weight-normal">({{CycleNo}})</label>
                    </div>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol Start:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocolst | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="Infertility!='null'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Infertility Type:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Infertility}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Donor:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorData}}</label>
                  </div>
                </div>
              </div>

              <div class="col-print-1"></div>

              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocol}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol End:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolEd | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Donor ID:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorCode}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">

            <div class="table-component margin-bottom-0px border4">
              <div class="table-responsive">


                <table class="table table-striped margin-left-zero">

                  <thead class="">
                    <tr>

                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-140px">Date</th>
                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">DOC</th>
                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">Endometrium</th>
                      <!--<th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">Comments</th>-->
                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">Ovaries Left</th>
                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">Ovaries Right</th>

                    </tr>

                  </thead>
                  <tbody class="table-body">
                    <tr *ngFor="let s of CurrentFollicularScanDetailController">


                      <td>
                        <label class="margin-bottom-0px font-family"> {{s.ScanDate| date:'MMM-dd-yyyy'}}</label>

                      </td>
                      <td>
                        <label class="margin-bottom-0px font-family"> {{s.DOC}}</label>
                      </td>
                      <td>
                        <div><label class="margin-bottom-0px font-family">{{s.EndometriumThickness}}{{s.EndometriumThicknessUnits}}</label></div>
                        <div class="font-family">{{s.EndometriumDetails}}</div>
                      </td>
                      <!--<td>
                <label class="margin-bottom-0px font-family">{{s.Comments}}</label>

              </td>-->
                      <td class="td-padding-tb align-top">

                        <div class="row margin-left-0px margin-right-0px">
                          <div class="col-print-2 padding-right-23px margin-top-10 margin-right-18px margin-bottom-3px" *ngFor="let od of GetOvaryDetails(s.FollicularGrowth, 'Left')">
                            <div class="badge badge-service2-left margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">

                              <div class="badge inner-badge2 border-radius-50p">{{od.Count}}</div>
                              <label class="margin-top-4px margin-bottom-3px font-family">{{od.Size}}</label>


                            </div>
                          </div>
                        </div>
                        <!--<div *ngFor="let l of CurrentFollicularScanOvaryDetailController">
                  <label class="margin-bottom-0px">{{l.OvarPos}}</label>
                </div>-->


                      </td>

                      <td class="td-padding-tb align-top">
                        <div class="row margin-left-0px margin-right-0px">
                          <div class="col-print-2 padding-right-23px margin-top-10 margin-right-18px" *ngFor="let od of GetOvaryDetails(s.FollicularGrowth, 'Right')">
                            <div class="badge badge-service2-right margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                              <!--<div class="row">
                        <label class="margin-bottom-0px margin-left-13px color-datacolor">4</label>
                      </div>-->
                              <div class="badge inner-badge2 border-radius-50p">{{od.Count}}</div>
                              <label class="margin-top-4px margin-bottom-3px font-family">{{od.Size}}</label>


                            </div>
                          </div>

                        </div>
                        <!--<div><label class="margin-bottom-0px">3(13.2)</label></div>
                <div><label class="margin-bottom-0px">1(17.5)</label></div>-->
                      </td>


                    </tr>

                  </tbody>

                </table>
              </div>
            </div>
          </div>

          <!--<div class="col-print-12">
    <div class="row margin-left-0px margin-right-0px">
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family"></label>
      </div>
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family"></label>
      </div>
    </div>
  </div>
  <div class="col-print-12">
    <div class="row margin-left-0px margin-right-0px">
      <div class="col-print-7">
        <label class="margin-bottom-0px font-family">Doctor</label>
      </div>
      <div class="col-print-5">
        <label class="margin-bottom-0px font-family">Assistant</label>
      </div>
    </div>
  </div>
  <div class="col-print-12">
    <div class="row margin-left-0px margin-right-0px">
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family"></label>
      </div>
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family"></label>
      </div>
    </div>
  </div>
  <div class="col-print-12">
    <div class="row margin-left-0px margin-right-0px">
      <div class="col-print-7">
        <div class="row margin-left-0px margin-right-0px">
          <div class="col-print-4 border-bot-1px">
            <label class="margin-bottom-0px font-family text-align-center">{{Sign1}}</label>
          </div>
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family"></label>
          </div>
        </div>
      </div>
      <div class="col-print-5">
        <div class="row margin-left-0px margin-right-0px">
          <div class="col-print-6 border-bot-1px">
            <label class="margin-bottom-0px font-family text-align-center">{{Sign2}}</label>
          </div>
          <div class="col-print-5">
            <label class="margin-bottom-0px font-family"></label>
          </div>
        </div>
      </div>
    </div>
  </div>-->

          <!--<div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-12">
                <ivf-additional-detail [CycleCode]='CycleCode'
                                       Title="Additional Information"
                                       Context="FolScanAdnlDetail">
                </ivf-additional-detail>
              </div>
            </div>
          </div>-->

        </div>
      </div>
    </div>
  </div>
</div>
<!--<printfooterview [Sign1]="Sign1" [Sign2]="Sign2"></printfooterview>-->
